import React from 'react'
import { useParams } from 'react-router'
import { withRouter } from 'react-router-dom'
import { SmallDown, SmallUp } from 'components/Responsive/breakpoints'
import DefaultDriverDesktopLayout from 'components/layout/DefaultDriverDesktopLayout'
import PartnerAgreementContent, {
  getPartnerAgreementTerms,
} from 'components/DriversApp/PartnerAgreementContent'
import { useGetInitialFormValues } from 'hooks'
import LoadingSpinner from 'components/LoadingSpinner'

const PartnersAgreement = ({ history }) => {
  const { token } = useParams()
  const { currentItem: company, isLoading } = useGetInitialFormValues(
    token ? `external/company/${token}` : null
  )

  const partnerName = company?.name || ''
  const partnerAddress = company?.address || ''
  const selectedTerms = getPartnerAgreementTerms(company?.place?.country)

  const renderDocument = () => (
    <div className='driver-booking-container' style={{ margin: 0 }}>
      <div className='driver-service-card assign-card partner-document-card'>
        <div className='partner-document-body'>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <PartnerAgreementContent
              partnerName={partnerName}
              partnerAddress={partnerAddress}
              selectedTerms={selectedTerms}
            />
          )}
        </div>
      </div>
    </div>
  )

  return (
    <>
      <SmallUp>
        <DefaultDriverDesktopLayout
          data={{ name: "Partner's Agreement" }}
          renderContent={renderDocument}
        />
      </SmallUp>
      <SmallDown>
        <div className='driver-edit-container partner-document-mobile'>
          <img
            className='driver-back-icon-account'
            src='/images/icon-back.png'
            onClick={history.goBack}
            alt=''
          />
          <div className='driver-booking-container-header'>
            Partner&apos;s Agreement
          </div>
          <div className='partner-document-mobile-body'>{renderDocument()}</div>
        </div>
      </SmallDown>
    </>
  )
}

export default withRouter(PartnersAgreement)
